import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import TierIcon from '@wix/da-ds/pkg/Icons/16x16/Tier';
import BoostIcon from '@wix/da-ds/pkg/Icons/16x16/BoostFilled';
import StatisticsBar from './StatisticsBar';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './TierStatisticsBar.scss';
/** Statistics bar specifically for Tiers to consolidate some code.
 *  Currently only shows subscriber counts (if any) */ const TierStatisticsBar = ({ stats, isBoosted, className })=>{
    const { t } = useTranslation();
    const is_booster = useFlag('booster');
    const numSubscribers = stats === null || stats === void 0 ? void 0 : stats.subscribers;
    if (!numSubscribers && !(is_booster && isBoosted)) {
        return null;
    }
    const statItems = [
        {
            icon: TierIcon,
            label: t('deviationview.tierCard.subscribers', {
                count: numSubscribers
            })
        }
    ];
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(StatisticsBar, {
        className: s['stats'],
        stats: statItems
    }), is_booster && isBoosted && /*#__PURE__*/ React.createElement("div", {
        className: s['boosted']
    }, /*#__PURE__*/ React.createElement(BoostIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['boosted-text']
    }, t('common.boosted'))));
};
TierStatisticsBar.displayName = 'TierStatisticsBar';
export default TierStatisticsBar;

//# sourceMappingURL=TierStatisticsBar.js.map